<template>
    <div id="date_picker">
        <el-date-picker
            v-if="(style.width > 752) && (type == 'daterange' || type == 'datetimerange')"
            :class="(is_row) ? 'next_input_row' : ''"
            :style="(width) ? {width: width+'px !important'} : {width:'100%'}"
            v-model="dates"
            unlink-panels
            align="center"
            :type="type"
            :start-placeholder="$t('ui.el.datepicker.startDate')"
            :end-placeholder="$t('ui.el.datepicker.endDate')"
            :picker-options="$store.state.element_ui_datepicker_daterange_options">
        </el-date-picker>
        <el-date-picker
            v-else-if="(style.width > 752) && (type == 'datetime')"
            :class="(is_row) ? 'next_input_row' : ''"
            :style="(width) ? {width: width+'px !important'} : {width:'100%'}"
            v-model="dates[0]"
            type="datetime"
            :placeholder="$t('ui.el.datepicker.selectDateTime')">
        </el-date-picker>
        <div v-else
            class="fake_input"
            @click="$bus.$emit('date_picker_modal', 'show', type, datetimerange_channel_name)">
            <div style="float: left;"
                :style="(dates[0] && dates[1] && is_row) ? {lineHeight:'28px'} : {}">
                <i :class="[
                    (type == 'datetimerange' || type == 'datetime') ? 'el-icon-time' : 'el-icon-date'
                ]"></i>
            </div>
            <span v-if="(!dates[0] && !dates[1])" class="text">
                {{ $t('ui.el.datepicker.selectDate') }}
            </span>
            <span v-else>
                <span class="text">
                    {{ $moment(dates[0]).format(format) }}
                </span>
                <br v-if="is_row">
                <span v-if="!is_row && dates[1]" class="text"> ~ </span>
                <span v-if="dates[1]" class="text">
                    {{ $moment(dates[1]).format(format) }}
                </span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {
        re_init: {
            // 2019-07-25
            // This is very very bad plan.
            // Because I don't know how to watch v-model value.
            type: Boolean,
            default: () => { return false }
        },
        type: {
            type: String,
            default: () => { return 'datetimerange' }
        },
        is_row: {
            type: Boolean,
            default: () => { return false }
        },
        width: {
            type: Number,
            default: () => { return 0 }
        },
        format: {
            type: String,
            default: () => { return 'YYYY-MM-DD HH:mm:ss' }
        },
    },
    model: {
        prop: 'value', // return array, ex: ['2019-xx-xx 00:00:00','2019-xx-xx 23:59:59']
        event: 'update'
    },
    data() {
        return {
            is_initialized: false,
            datetimerange_channel_name: "datetimerange_channel",
            dates: [],
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
    },
    watch: {
        dates(val) {
            let result = (val == null) ? [null,null] : val
            this.$forceUpdate()
            if (Array.isArray(result)) {
                this.update_value(result)
            }
        },
        re_init(val) {
            this.init()
        }
    },
    mounted() {
        this.init()
        this.datetimerange_channel_name = this.datetimerange_channel_name + this.$vnode.data.key
        this.$bus.$off(this.datetimerange_channel_name)
        this.$bus.$on(this.datetimerange_channel_name, (val) => {
            if (this.type == 'datetime') {
                val[1] = null
            }
            this.dates = _.clone(val)
        })
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.current_index = null
                resolve()
            })
            await new Promise(resolve => {
                let default_value = null
                try {
                    default_value = this.$vnode.data.props.value
                    if (default_value) {
                        if (Array.isArray(default_value)) {
                            this.dates = [
                                default_value[0] == null ? "" : default_value[0],
                                default_value[1] == null ? "" : default_value[1]
                            ]
                        } else {
                            this.dates[0] = default_value
                        }
                    } else {
                        this.dates = ["", ""]
                    }
                    this.$forceUpdate()
                } catch (e) {

                }
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        set_current_index(val) {
            this.current_index = val
        },
        update_value(val) {
            if (this.type == 'datetimerange') {
                if (this.$moment(val[0]).unix() == this.$moment(val[1]).unix()) {
                    val[1] = date_to_end(val[1])
                }
            }
            let result = (this.type == 'datetime') ? val[0] : val
            this.$emit('update', result)
        }
    },
}
</script>

<style scoped lang="scss">
    #date_picker {
        & {
            cursor: pointer;
        }
        .fake_input {
            border: 1px solid rgba(34,36,38,.15);
            text-align: left;
            padding: .67857143em 1em;
        }
        .text {
            padding-left: 9px;
        }
    }
</style>
